import { createSlice } from '@reduxjs/toolkit';
import CITY_MUNIS from 'assets/json/city_muni_denormalized.json';
import PROVINCES from 'assets/json/province.json';

const getBbox = (state) => {
  const provinces = state.provinces;
  const cityMunis = state.cityMunis;
  const shouldIgnoreProvince = provinces.length === 1 && cityMunis.length > 0;
  let allBboxes = cityMunis.map((cm) => cm.bbox);
  if (!shouldIgnoreProvince) {
    allBboxes = [...allBboxes, ...provinces.map((p) => p.bbox)];
  }
  if (allBboxes.length > 0) {
    // not sure if it's better to do a single reduce for allBboxes with multiple minmax calls
    return {
      xmin: Math.min(...allBboxes.map((bb) => bb.xmin)),
      xmax: Math.max(...allBboxes.map((bb) => bb.xmax)),
      ymin: Math.min(...allBboxes.map((bb) => bb.ymin)),
      ymax: Math.max(...allBboxes.map((bb) => bb.ymax)),
    };
  }
};

const slice = createSlice({
  name: 'location',
  initialState: {
    provinces: [],
    provincePsgcs: [],
    cityMunis: [],
    cityMuniPsgcs: [],
    bbox: null,
    provinceMap: PROVINCES.reduce((map, p) => {
      map[p.ADM2_PCODE] = p.ADM2_EN;
      return map;
    }, {}),
    cityMuniMap: CITY_MUNIS.reduce((map, cm) => {
      map[cm.ADM3_PCODE] = cm.ADM3_EN;
      return map;
    }, {}),
  },
  reducers: {
    setProvinces: (state, action) => {
      state.provinces = action.payload;
      state.provincePsgcs = action.payload.map((p) => p.ADM2_PCODE);
      state.bbox = getBbox(state);
    },
    setCityMunis: (state, action) => {
      state.cityMunis = action.payload;
      state.cityMuniPsgcs = action.payload.map((cm) => cm.ADM3_PCODE);
      state.bbox = getBbox(state);
    },
  },
});

export default slice.reducer;

export const setProvinces = (payload) => ({ type: 'location/setProvinces', payload });
export const setCityMunis = (payload) => ({ type: 'location/setCityMunis', payload });
